<app-wizard-step-wrapper
  [showStep]="showStep"
  [stepTitle]="stepMetadata.stepName"
  [hideHeader]="isIdVerificationComplete$ | async"
  [formGroup]="formStep"
  >
  @if (isIdVerificationComplete$ | async) {
    <div
      class="id-verification-complete step-container"
      >
      <div class="id-verification-complete__message">
        <img
          src="../../../../../assets/images/identity_success.svg"
          alt="ID Card with green checkmark"
          />
          <h3>Successfully Submitted</h3>
          <p>You may now proceed with the security questions.</p>
        </div>
        <app-button-container>
          <app-button [dataTestId]="'next-button-id-complete'" type="primary" (buttonClick)="goToNextStep()"
            >Next</app-button
            >
          </app-button-container>
        </div>
      } @else {
        <div class="id-verification-in-progress step-container">
          <h3 class="form-step__subheading">
            {{ user?.firstName }}, your ID verification is still in progress.
          </h3>
          <app-alert-banner [type]="'information'" [message]="bannerMessage">
          </app-alert-banner>
          <div class="button-container">
            <div class="form-step__text">
              Accidentally close the ID Verification process? Use the
              <span class="form-step__text--bold">Previous</span> button to return to the last step and
              restart it.
            </div>
            <app-button-container>
              <app-button
                [dataTestId]="'previous-button-id-in-progress'"
                type="tertiary"
                (buttonClick)="goToPreviousStep()"
                >
                Previous
              </app-button>
              @if (shouldBypassRealId$ | async) {
                <app-button
                  [dataTestId]="'next-button-id-in-progress'"
                  type="primary"
                  (buttonClick)="completeFakeIdVerification()"
                  >
                  Next
                </app-button>
              }
            </app-button-container>
          </div>
        </div>
      }
    </app-wizard-step-wrapper>

